export const capitalizeFirstLetter = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1)
}

export const removeSpecialsAndWhitespaces = (str: string) => str.replace(/[^A-Z0-9]/gi, '')

export const detectNewline = (str: string) => {
	return str.replace(/\n/g, '<br/>')
}

export const returnCurrentURL = (route: any) => {
	return route.fullPath
}

// Appends the brand to a <title>, unless it's already there (CMS-editable titles
// sometimes already include it, hardcoded fallbacks never do).
export const ensureBrandSuffix = (title?: string | null, brand: string = 'CarFree') => {
	if (!title || !title.trim()) return title ?? ''
	const trimmed = title.trim()
	if (trimmed.toLowerCase().endsWith(brand.toLowerCase())) return trimmed
	return `${trimmed} | ${brand}`
}
